import store from './../../store';
import DAODiamondStock from "@/assets/DAO/DiamondStock";

let DAODiamond = function () {
	this.getData = function(country, diamondId) {
		return new Promise((resolve) => {
			let url		= store.getters["config/getDiamondStockUrl"] + "/Designer/diamondsGetData.php";
			let data	= new FormData();

			data.append('code', country);
			data.append('pool_id', diamondId);
			data.append('ac', 'get_article');

			fetch(url, {
				method: 'post',
				body: data
			}).then(response => {
				response.json().then(json => {
					if (typeof json.article == 'object') {
						json.article.certificateNr	= json.article.cert_nr;
						json.article				= DAODiamondStock.fixCertificate(json.article);
					}
					resolve(json);
				});
			});
		});
	}

	this.getItemnumber = function(diamondId) {
		return new Promise((resolve, reject) => {
			let url = store.getters["config/getApiHostWithLocalStr"] + '/v2/items/get/diamond/' + diamondId + '/';

			fetch(url, {
				method: 'get'
			}).then(response => {
				response.json().then(json => {
					if (typeof json.status === "boolean") {
						if (json.status === true && json.result.itemnumber) {
							resolve(json.result.itemnumber);
						} else {
							reject(json.alerts);
						}
					} else {
						reject(false);
					}
				});
			});
		});
	}

	this.addToItems = (diamondId, list) => {
		return new Promise((resolve, reject) => {
			let url		= store.getters["config/getApiHostWithLocalStr"] + '/v2/items/update/diamondAndPrice/' + diamondId + '/' ;
			let data	= new FormData();
			data.append('data', JSON.stringify(list));

			fetch(url, {
				method: 'post',
				body: data
			}).then(response => {
				response.json().then(json => {
					if (typeof json.status === "boolean") {
						if (json.status === true && (json.result.length) > 0) {
							resolve(json.result, json.alerts);
						} else {
							reject(false);
						}
					} else {
						reject(json.status);
					}
				});
			});
		});
	}
}

export default new DAODiamond();
